import { getFullUrl } from 'hubspot-url-utils';
import { createClient } from 'usage-tracker-core';
import { genericClient } from 'usage-tracker-core/client';
import { sendEventsViaFetch } from 'usage-tracker-core/client/fetchClient';
import { ensureFn } from 'usage-tracker-core/common/helpers';
import { getEmailOnce } from './utils';
const origin = getFullUrl('tools', {
  domainOverride: 'hubteam'
});
const path = '/usage-logging/v1/log/hublytics-multi/no-auth';

// Defines internal constants for the HubTools client.
const HUBSPOT_TOOLS_CONFIG = {
  hubId: 53,
  lang: 'en'
};
const reportNetworkError = err => {
  return genericClient.reportError(err, {
    fingerprint: ['usage-tracker-js', 'network']
  });
};
const hubtoolsTrackingClient = createClient({
  clientName: 'tools',
  getDebug: genericClient.getDebug,
  getHstc: genericClient.getHstc,
  getTempStorage: genericClient.getTempStorage,
  setTempStorage: genericClient.setTempStorage,
  logWarning: genericClient.logWarning,
  logError: genericClient.logError,
  reportWarning: genericClient.reportWarning,
  reportError: genericClient.reportError,
  getEmail: getEmailOnce,
  getHubId: () => HUBSPOT_TOOLS_CONFIG.hubId,
  getLang: () => HUBSPOT_TOOLS_CONFIG.lang,
  send: ({
    events: data,
    query = '',
    onFailure
  }) => {
    const endpoint = `${origin}${path}?${query}`;
    const handleRequestFailure = error => {
      reportNetworkError(error);
      ensureFn(onFailure)();
    };
    const sendXhr = () => {
      sendEventsViaFetch(endpoint, {
        data
      }).catch(handleRequestFailure);
    };
    genericClient.sendBeacon(endpoint, data, sendXhr);
  }
});
export default hubtoolsTrackingClient;